import { Box, CircularProgress, Typography } from "@mui/material";
import { AppConfig, centeredBoxSx, createOidcConfig } from "@shared";
import { useQuery } from "@tanstack/react-query";

import { useTranslation } from "@/translations";

import App from "../App";

export function AppBootstrap() {
  const { t } = useTranslation();
  const {
    data: config,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["appConfig"],
    queryFn: async () => {
      const response = await fetch("/api/application-settings");
      if (!response.ok) {
        throw new Error(`Config request failed with status ${response.status}`);
      }
      return response.json() as Promise<AppConfig>;
    },
    staleTime: Infinity,
    retry: 2,
  });

  if (isLoading) {
    return (
      <Box sx={centeredBoxSx}>
        <CircularProgress />
        <Typography>{t("auth.loading")}</Typography>
      </Box>
    );
  }

  if (error || !config) {
    return (
      <Box sx={centeredBoxSx}>
        <Typography color="error">{t("auth.loadError")}</Typography>
      </Box>
    );
  }

  const oidcConfig = createOidcConfig(config);
  return <App oidcConfig={oidcConfig} />;
}
